var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8212 9.00013L17.4573 3.36408C17.5918 3.22962 17.6673 3.04727 17.6673 2.85712C17.6673 2.66698 17.5918 2.48462 17.4573 2.35016L15.6507 0.543545C15.5162 0.40909 15.3339 0.333553 15.1437 0.333553C14.9536 0.333553 14.7712 0.40909 14.6368 0.543545L9.00064 6.17957L3.36454 0.543488C3.23008 0.409034 3.04771 0.333496 2.85757 0.333496C2.66742 0.333496 2.48506 0.409034 2.35061 0.543488L0.543968 2.3501C0.409527 2.48456 0.334001 2.66692 0.334001 2.85707C0.334001 3.04721 0.409527 3.22957 0.543968 3.36403L6.18007 9.00013L0.543968 14.6363C0.409526 14.7707 0.333984 14.9531 0.333984 15.1432C0.333984 15.3334 0.409526 15.5158 0.543968 15.6502L2.35061 17.4568C2.48506 17.5913 2.66742 17.6668 2.85757 17.6668C3.04771 17.6668 3.23008 17.5913 3.36454 17.4568L9.00064 11.8207L14.6368 17.4568C14.7712 17.5913 14.9536 17.6668 15.1437 17.6668C15.3339 17.6668 15.5162 17.5913 15.6507 17.4568L17.4573 15.6502C17.5918 15.5158 17.6673 15.3334 17.6673 15.1432C17.6673 14.9531 17.5918 14.7707 17.4573 14.6363L11.8212 9.00013Z",
    fill: "#F54A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.7257b761e50c23d96ea438afea4944ac.svg";
export { ForwardRef as ReactComponent };